import React from 'react';

const StackGraphZoomControls = ({ zoom, onZoomIn, onZoomOut, onReset }) => (
  <div className="stack-graph-zoom">
    <button type="button" className="stack-graph-zoom-btn" onClick={onZoomOut} aria-label="Zoom out">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
        <path d="M5 12h14" />
      </svg>
    </button>
    <button type="button" className="stack-graph-zoom-reset" onClick={onReset} aria-label="Reset zoom">
      {Math.round(zoom * 100)}%
    </button>
    <button type="button" className="stack-graph-zoom-btn" onClick={onZoomIn} aria-label="Zoom in">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
        <path d="M12 5v14M5 12h14" />
      </svg>
    </button>
  </div>
);

export default StackGraphZoomControls;
